import React, { Component } from 'react';
import {Head, withRouteData} from 'react-static';
import QueryString from 'query-string';

import { setReferrer } from '../utils/CookiesHelper';

import Header from '../components/Header';
import Cover from '../components/Cover';
import Features from '../components/Features';
import Network from '../components/Network';
import Enumeration from '../components/EnumerationScroll';
import Roadmap from '../components/Roadmap';
import Partners from '../components/Partners';
import Outro from '../components/Outro';
import Footer from '../components/Footer';
import Countdown from "../components/Countdown";
import SocialLinks from "../components/SocialLinks";
import FBF from "../components/FBF";

class Index extends Component {
	constructor(props) {
		super(props);
		if (typeof window !== 'undefined' && QueryString.parse(location.search).ref !== undefined && QueryString.parse(location.search).ref !== null) {
			setReferrer(QueryString.parse(location.search).ref);
		}
	}

	render() {
		return (
			<div>
				<Head>
					<title>Capacity Transfer Radio — Innovative radio technology | CTR Group</title>
					<meta name="description" content="CTR is a revolutionary technology designed to bring cellular technology to remote areas. CTR Group is looking for venture investors and backers! Learn more…" />

					<meta name="og:title" content="CTR Group ICO" />
					<meta name="og:description" content="CTR is a revolutionary technology designed to bring cellular technology to remote areas. Now CTR Group is launching an ICO to make it accessible for everyone! Learn more…" />
					<meta name="og:image" content="https://ctr.group/og-img.png" />
					<meta name="og:url" content="https://ctr.group/" />
					<meta name="og:site_name" content="CTR Group" />
					<meta name="og:type" content="website" />

                    <script type="application/ld+json">
                        {`
                        {
                            "@context": "http://schema.org",
                            "@type": "Corporation",
                            "name": "CTR Group",
                            "alternateName": "CTR Technology",
                            "url": "https://ctr.group",
                            "logo": "https://ctr.group/logo.png"
                        }
                        `}
                    </script>
                </Head>
				<Header/>
				<Cover/>
				{/*<FBF />*/}
				{/*<Countdown />*/}
				<Features/>
				<Network/>
				<Enumeration/>
				<Roadmap/>
				<Partners/>
				<Outro/>
				<SocialLinks />
				<Footer/>
			</div>
		)
	}
}

export default withRouteData(Index)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Index.js